<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel mt-20">
      <div class="order-option-header mb-15">
        <h6 style="display: flex; align-items: center">
          订单编号 {{ order.number
          }}<el-tag
            v-if="order.id"
            effect="dark"
            size="mini"
            :type="
              CommodityOrderStatusMap[
                order.approve_status == 2 ? 2 : order.status
              ].type
            "
            class="ml-10"
            >{{
              CommodityOrderStatusMap[
                order.approve_status == 2 ? 2 : order.status
              ].name
            }}</el-tag
          >
        </h6>
        <div class="flex">
          <el-popconfirm
            v-show="order.status == 2 || order.status == 5"
            v-permission="Auth.commodityOrderCancel"
            :title="`确认取消吗？`"
            @confirm="handleCancel"
          >
            <el-button slot="reference" type="danger" plain size="mini"
              >取消</el-button
            >
          </el-popconfirm>
          <el-popconfirm
            v-permission="Auth.commodityOrderDelete"
            :title="`确认删除吗？`"
            v-show="order.status == 1 || order.status == 3"
            @confirm="handleDelete"
          >
            <el-button slot="reference" type="danger" plain size="mini"
              >删除</el-button
            >
          </el-popconfirm>
          <el-popconfirm
            v-permission="Auth.commodityOrderItemUpdate"
            title="确认退回商品编辑吗？"
            v-show="
              order.is_quotation == 1 && order.status < 6 && order.status != 4
            "
            @confirm="handleReturn"
          >
            <el-button slot="reference" type="primary" plain size="mini"
              >退回商品编辑</el-button
            >
          </el-popconfirm>
          <template v-if="order.is_quotation > 1">
            <el-popconfirm
              v-permission="Auth.commodityOrderItemUpdate"
              title="确认删除吗？"
              v-if="order.status == 0"
              @confirm="handleDelete"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              v-permission="Auth.commodityOrderItemUpdate"
              v-if="order.status == 0"
              @click="
                $router.push('/dashboard/shop/orders/editor?order=' + order.id)
              "
              >编辑</el-button
            >
            <el-popconfirm
              v-permission="Auth.commodityOrderItemUpdate"
              title="确认提交审核吗？"
              v-if="order.status == 0"
              @confirm="handleApplication"
            >
              <el-button
                slot="reference"
                class="ml-10"
                type="primary"
                plain
                size="mini"
                >提交审核</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              v-permission="Auth.commodityOrderItemUpdate"
              title="确认退回重新编辑吗？"
              v-if="order.status == 3"
              @confirm="handleApplication"
            >
              <el-button
                slot="reference"
                class="ml-10"
                type="primary"
                plain
                size="mini"
                >退回编辑</el-button
              >
            </el-popconfirm>
          </template>

          <div
            v-permission="Auth.commodityOrderContractExport"
            v-if="
              (order.status == 5 && order.approve_status != 2) ||
              order.status == 6 ||
              order.status == 12 ||
              order.status == 13 ||
              order.status == 100
            "
          >
            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              v-if="order.is_quotation == 1"
              @click="handleContractExport"
              >合同导出</el-button
            >
            <el-dropdown v-else @command="handleContractExport">
              <el-button size="small" type="primary" class="ml-10" plain
                >合同导出<i class="el-icon-arrow-down el-icon--right"></i
              ></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">销售报价单</el-dropdown-item>
                <el-dropdown-item command="0">销售合同书</el-dropdown-item>
                <el-dropdown-item command="2">现场维修合同书</el-dropdown-item>
                <el-dropdown-item command="3">维修合同书</el-dropdown-item>
                <el-dropdown-item command="4"
                  >原厂基本维修服务合同</el-dropdown-item
                >
                <el-dropdown-item command="5"
                  >原厂维护保养合同</el-dropdown-item
                >
                <el-dropdown-item command="6"
                  >原厂翻新服务合同</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <el-form
        :model="order"
        label-position="right"
        size="mini"
        label-width="120px"
      >
        <el-form-item label="Quotation码：" v-if="order.status == 100">
          <div>
            <template v-if="!editModel.edit">
              {{ order.quotation_number || '无'
              }}<el-button
                size="mini"
                type="text"
                class="ml-10"
                v-permission="Auth.commodityOrderUpdate"
                @click="
                  editModel.quotation_number = order.quotation_number
                  editModel.edit = true
                "
                >修改</el-button
              >
            </template>
            <template v-else>
              <el-input
                style="width: 120px"
                v-model="editModel.quotation_number"
              ></el-input>
              <el-button
                size="mini"
                type="text"
                class="ml-10"
                @click="editModel.edit = false"
                >取消</el-button
              >
              <el-button
                size="mini"
                type="text"
                class="ml-10"
                @click="handleOrderUpdate"
                >保存</el-button
              >
            </template>
          </div>
        </el-form-item>
        <el-form-item label="创建时间：">
          <div>
            {{ $time(new Date(order.created_at)).format('YYYY-MM-DD HH:mm') }}
          </div>
        </el-form-item>
        <el-form-item label="创建人：" v-if="auth.isPlatformUser()">
          <div v-if="order.user_id && order.is_quotation != 3">
            {{ order.user.name }}（{{ order.user.phone_number }}）
          </div>
          <div v-else-if="order.customer_user_id">
            {{ order.customer_user.name }}（{{ order.customer_user.mobile }}）
          </div>
        </el-form-item>
        <el-form-item label="订单来源：" v-if="auth.isPlatformUser()">
          {{ CommodityOrderQuotationMap[order.is_quotation] }}
        </el-form-item>
        <el-form-item label="合同编号：">
          <div>
            {{ order.contract_number ? order.contract_number : order.number }}
          </div>
        </el-form-item>
        <template v-if="order.is_quotation != 1 && auth.isPlatformUser()">
          <el-form-item label="报价类型：" v-if="order.quotation_type">
            <div>
              {{ order.quotation_type == 2 ? '服务报价' : '备件报价' }}
            </div>
          </el-form-item>
          <el-form-item label="报价客户：">
            <customer-link :customer="order.quotation_customer"></customer-link>
          </el-form-item>
          <el-form-item label="项目信息：">
            {{ order.project_name }}
          </el-form-item>
          <el-form-item label="联系人：">
            <template v-if="order.customer_contact_id > 0">
              {{ order.customer_contact.name }}（{{
                order.customer_contact.mobile
              }}）
            </template>
          </el-form-item>
          <el-form-item
            label="机会种类："
            v-if="order.business_opportunity_type"
          >
            <BusinessOpportunitySelector
              :val="order.business_opportunity_type"
            ></BusinessOpportunitySelector>
          </el-form-item>
        </template>

        <el-form-item
          label="批量订单："
          v-if="order.department_id == 1 && order.is_quotation == 1"
        >
          <div>
            {{ order.bq == 2 ? '是' : '否' }}
          </div>
        </el-form-item>
        <el-form-item
          label="中间商："
          v-if="order.is_quotation == 1 && auth.isPlatformUser()"
        >
          <div v-if="order.dealer_id">
            {{ order.dealer.name }}
          </div>
        </el-form-item>
        <el-form-item
          label="EC有效期："
          v-if="
            auth.isPlatformUser() &&
            order.flows.filter((item) => item.category == 20).length > 0
          "
        >
          <div>
            {{
              order.dealer.ec_deadline == null
                ? '无'
                : $time(order.dealer.ec_deadline).format('YYYY-MM-DD')
            }}
          </div>
        </el-form-item>
        <el-form-item label="最终客户：">
          <div>{{ order.customer.name || '无' }}</div>
        </el-form-item>
        <el-form-item label="最终用途：">
          <div>{{ order.usage || '无' }}</div>
        </el-form-item>
        <el-form-item label="收货信息：">
          <div class="receive-info">
            <template v-if="order.receive_address_id">
              <span class="mr-20">{{ order.receive_address.contact_name }}</span
              ><span class="mr-20"
                >{{ codeToText[order.receive_address.province] }}
                {{ codeToText[order.receive_address.city] }}
                {{ codeToText[order.receive_address.county] }}
                {{ order.receive_address.detail }}</span
              ><span class="mr-20">
                {{ order.receive_address.contact_phone }}
              </span>
            </template>
          </div>
        </el-form-item>
        <el-form-item label="发票邮寄信息：">
          <div class="receive-info">
            <template v-if="order.invoice_address_id">
              <span class="mr-20">{{ order.invoice_address.contact_name }}</span
              ><span class="mr-20"
                >{{ codeToText[order.invoice_address.province] }}
                {{ codeToText[order.invoice_address.city] }}
                {{ codeToText[order.invoice_address.county] }}
                {{ order.invoice_address.detail }}</span
              ><span class="mr-20">
                {{ order.invoice_address.contact_phone }}
              </span>
              <span>
                {{ order.invoice_address.email }}
              </span>
            </template>
          </div>
        </el-form-item>

        <el-form-item label="支付方式：" v-if="order.payed_at">
          <div>
            <div style="display: flex">
              <div>
                <div>{{ order.pay_type == 1 ? '线下支付' : '银联支付' }}</div>
                <div class="font-12" style="line-height: 1.5em">
                  {{ $time(new Date(order.payed_at)).format('YYYY-MM-DD') }}
                </div>
              </div>

              <div v-if="order.payed_proof" class="flex">
                <auth-img
                  tag="el-image"
                  :src="order.payed_proof"
                  :preview-src-list="[order.payed_proof]"
                  style="
                    width: 50px;
                    height: 50px;
                    margin-left: 5px;
                    margin-top: 5px;
                  "
                  fit="cover"
                  class="small"
                ></auth-img>
              </div>
            </div>
            <div v-if="order.payed_remark">
              {{ order.payed_remark }}
            </div>
          </div>
        </el-form-item>
        <el-form-item
          :label="order.is_quotation == 2 ? '备注：' : '买家留言：'"
        >
          <div>{{ order.remark || '无' }}</div>
        </el-form-item>
        <el-form-item label="销售合同：">
          <div class="flex">
            <a
              v-if="order.contract"
              :href="order.contract.url + '?t=' + FileToken"
              target="_blank"
              >{{ order.contract.name }}</a
            >
            <span v-else>无</span>
            <el-upload
              v-permission="Auth.commodityOrderContractEdit"
              v-if="order.status == 6 || order.status == 100"
              class="avatar-uploader ml-10"
              :action="fileUploadUrl"
              :multiple="false"
              :show-file-list="false"
              accept=".pdf"
              :headers="uploadHeader"
              :on-success="handleFileSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
            >
              <el-button size="mini" plain type="primary">上传</el-button>
              <!-- <div slot="tip" class="el-upload__tip">
                最多10个文件，支持格式：.doc(x),.xls(x),.pdf，单个文件不超过10M
              </div> -->
            </el-upload>
            <el-button
              size="mini"
              type="primary"
              plain
              class="ml-10"
              v-permission="Auth.commodityOrderContractEdit"
              v-if="order.contract"
              @click="download(order.contract)"
              >下载</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div class="panel mt-20" v-if="auth.isPlatformUser() && order.status != 0">
      <p>订单流程</p>
      <div class="mb-20 ml-20">
        <el-steps
          :space="220"
          finish-status="success"
          :active="flowActiveIndex"
          :key="flowKey"
        >
          <el-step
            :title="flow.categoryName"
            :key="flow.id"
            v-for="(flow, index) in approveflows"
            :status="flow.operate_type == 2 && flow.status == 1 ? 'error' : ''"
            class="order-step"
          >
            <div slot="description">
              <div
                v-if="
                  index == flowActiveIndex &&
                  (order.status == 2 ||
                    order.status == 4 ||
                    order.status == 5 ||
                    order.status == 12)
                "
              >
                <div
                  style="color: #2f7bf8"
                  v-if="flow.category != 1 && flow.category != 50"
                >
                  {{ flow.category == 3 ? '商品编辑中...' : '审批中...' }}
                </div>
              </div>
              <div v-if="flow.status == 1">
                <p class="mb-0 mt-5" v-if="flow.category == 1">创建订单</p>
                <p class="mb-0 mt-5" v-else-if="flow.category == 50">
                  客户 支付
                </p>
                <p class="mb-0 mt-5" v-else>
                  {{ flow.operator.name }}
                  <template v-if="flow.category == 5">
                    {{
                      order.bq == 2
                        ? '审批通过'
                        : '审批通过（变更为非批量订单）'
                    }}
                  </template>
                  <template v-else-if="flow.category == 3"> 商品编辑 </template>
                  <template v-else>
                    {{ flow.operate_type == 1 ? '审批通过' : '审批不通过' }}
                  </template>
                </p>
                <p class="mb-5">
                  {{
                    $time(flow.operate_time).format(
                      flow.category == 50 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm',
                    )
                  }}
                </p>
                <p class="mb-5">{{ flow.operate_remark }}</p>
              </div>
              <el-popover
                placement="top-start"
                title=""
                width="375"
                trigger="hover"
                v-if="
                  flow.desc && flow.category == 40 && index <= flowActiveIndex
                "
                :content="flow.desc"
              >
                <el-link
                  :underline="false"
                  slot="reference"
                  style="font-size: 12px !important"
                  type="primary"
                  >申请详情<i class="el-icon-view el-icon--right"></i
                ></el-link>
              </el-popover>
            </div>
          </el-step>
        </el-steps>
      </div>

      <div
        class="approve-container"
        v-if="canApproveFlow(approveflows[flowActiveIndex])"
      >
        <template v-if="approveflows[flowActiveIndex].category == 3">
          <el-button
            type="primary"
            size="small"
            style="width: 120px"
            @click="handleApprove(approveflows[flowActiveIndex].category)"
            >完成商品编辑</el-button
          >
        </template>
        <template v-else>
          <div class="mb-5">
            审批原因：{{ approveflows[flowActiveIndex].desc }}
          </div>
          <el-button
            type="primary"
            size="small"
            style="width: 80px"
            @click="handleApprove(approveflows[flowActiveIndex].category)"
            >审批</el-button
          >
        </template>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="item-title mb-20">
        <span>商品信息</span>
        <div>
          <el-button
            size="small"
            type="primary"
            plain
            v-if="canEditItem"
            @click="productSelectorVisible = true"
            >添加商品</el-button
          >
        </div>
      </div>
      <el-form
        :model="order"
        label-position="right"
        size="mini"
        label-width="20px"
      >
        <el-form-item label="" class="mb-20">
          <el-table
            v-if="!isMobile()"
            :data="order.items"
            border
            size="mini"
            style="width: 100%"
          >
            <el-table-column align="left" label="商品" min-width="200px">
              <template slot-scope="scope">
                <div class="item-container">
                  <div class="flex-row">
                    <auth-img
                      tag="el-image"
                      :src="scope.row.cover"
                      style="width: 60px; height: 60px"
                      fit="cover"
                      ><div slot="error" class="image-slot">
                        暂无图片
                      </div></auth-img
                    >
                  </div>
                  <div class="item-info">
                    <!-- <span>{{ scope.row.name }}</span> -->
                    <span class="part-number"
                      >{{ scope.row.part_number
                      }}<i class="font-12 font-normal"
                        >（{{ scope.row.type_name }}）</i
                      >
                      <template v-if="userInfo.dealer_id == 0">
                        <el-tag
                          size="mini"
                          type="danger"
                          class="mr-5"
                          v-if="
                            order.status == 2 && scope.row.whether_approve == 2
                          "
                          >下单审批</el-tag
                        ><el-tag
                          size="mini"
                          type="danger"
                          v-if="
                            (order.status == 2 || order.status == 12) &&
                            scope.row.whether_approve != 2 &&
                            scope.row.ec_approve == 2
                          "
                          >EC审批</el-tag
                        >
                      </template>
                    </span>
                    <span>
                      <el-tag size="mini">{{
                        scope.row.commodity_category_name
                      }}</el-tag>
                    </span>
                    <!-- <span class="item-desc">{{ scope.row.description }}</span> -->
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              prop="description"
              min-width="140px"
              label="描述"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="customer_device_serial_number"
              min-width="90px"
              label="关联设备"
              v-if="userInfo.dealer_id == 0"
            >
            </el-table-column>
            <el-table-column align="center" label="单价（元）">
              <template slot-scope="scope">
                <el-input-number
                  v-if="scope.row.edit"
                  v-model="scope.row.discount_price"
                  :precision="2"
                  :step="1"
                  :min="0"
                ></el-input-number>
                <div v-else-if="userInfo.dealer_id == 0">
                  {{ scope.row.price.toFixed(2) }}（{{
                    ((scope.row.price / scope.row.original_price) * 10).toFixed(
                      1,
                    )
                  }}
                  折）
                  <br />
                  <span
                    class="text-danger"
                    v-if="
                      scope.row.discount_price &&
                      scope.row.discount_price != scope.row.price
                    "
                    >{{ scope.row.discount_price.toFixed(2) }}（待生效）</span
                  >
                </div>
                <div v-else>
                  {{ scope.row.price.toFixed(2) }}
                </div>
                <!-- <span v-else>{{ scope.row.price.toFixed(2) }}</span> -->
                <!-- <span class="item-price origin-price">{{
                  scope.row.original_price.toFixed(2)
                }}</span> -->
              </template>
            </el-table-column>
            <el-table-column align="center" label="数量" prop="number">
              <template slot-scope="scope">
                <el-input-number
                  :min="1"
                  :step="1"
                  v-if="scope.row.edit"
                  v-model="scope.row.number"
                ></el-input-number>
                <span v-else>{{ scope.row.number }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="小计（元）">
              <template slot-scope="scope">
                ￥{{ (scope.row.number * scope.row.price).toFixed(2) }}
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              label="操作"
              width="120"
              v-if="canEditItem"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="commodityItemUpdate(scope.$index, scope.row)"
                  v-if="scope.row.edit"
                  >保存</el-button
                >
                <el-button
                  type="text"
                  v-else
                  @click="commodityItemEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-popconfirm
                  title="确定删除该商品吗？"
                  @confirm="deleteCommodityItem(scope.$index, scope.row)"
                >
                  <el-button
                    type="text"
                    class="text-danger ml-5"
                    slot="reference"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>

      <div class="option-bar">
        <div class="optipn-fight">
          <div>
            商品总额（不含税）：<span
              >￥{{ order.no_tax_price.toFixed(2) }}</span
            >
          </div>
          <div>
            税费：<span>+ ￥{{ order.tax_fee.toFixed(2) }}</span>
          </div>
          <div v-if="order.labor_fee">
            杂项：<span>+ ￥{{ order.labor_fee.toFixed(2) }}</span>
          </div>
          <template v-if="order.is_quotation == 2">
            <div>
              折扣金额：<span
                >- ￥{{
                  (order.original_total_price - order.total_price).toFixed(2)
                }}</span
              >
            </div>
            <div v-if="userInfo.dealer_id == 0">
              折扣率：<span
                >{{
                  (
                    ((order.original_total_price - order.total_price) /
                      order.original_total_price) *
                    100
                  ).toFixed(2)
                }}%</span
              >
            </div>
          </template>
          <template v-else>
            <div v-if="order.discount">
              折扣金额：<span
                >- ￥{{
                  (
                    order.no_tax_price +
                    order.tax_fee -
                    order.total_price
                  ).toFixed(2)
                }}</span
              >
            </div>
            <div v-if="order.discount && userInfo.dealer_id == 0">
              折扣率：<span
                >{{ '- '
                }}{{
                  (
                    ((order.no_tax_price + order.tax_fee - order.total_price) /
                      order.original_total_price) *
                    100
                  ).toFixed(1)
                }}%</span
              >
            </div>
          </template>
          <div class="pay-amount">
            {{ order.status > 5 ? '实付' : '应付' }}金额（含税）：<span
              >￥{{ order.total_price.toFixed(2) }}</span
            >
          </div>
          <div
            v-if="
              order.is_quotation == 1 &&
              order.status == 5 &&
              hasAuth('commodityOrderDiscountApplication')
            "
          >
            <div class="mt-20" v-if="!discountEdit">
              <el-tag
                style="min-width: 0"
                class="mr-5"
                v-if="order.approve_status != 1"
                size="mini"
                :type="approveStatusMap[order.approve_status].type"
                >{{ approveStatusMap[order.approve_status].info }}</el-tag
              >折扣金额：<span>
                ￥{{ order.discount.toFixed(2)
                }}<i
                  class="text-primary discount-edit-btn"
                  @click="
                    order.origin_discount = order.discount
                    discountEdit = true
                  "
                  v-if="order.approve_status != 2"
                  >修改</i
                ></span
              >
            </div>
            <div class="mt-20" v-else>
              折扣金额：<span>
                ￥
                <el-input-number
                  class="text-right"
                  size="mini"
                  v-model="order.discount"
                  :precision="2"
                  :step="1"
                  :min="0.01"
                  :max="order.no_tax_price + order.tax_fee"
                  :controls="false"
                ></el-input-number>
              </span>
            </div>

            <div v-if="order.approve_status == 2 || discountEdit">
              折扣率：<span>
                {{
                  ((order.discount / order.original_total_price) * 100).toFixed(
                    1,
                  )
                }}%</span
              >
            </div>
            <div v-if="order.approve_status == 2 || discountEdit">
              折后应付总额：<span>
                ￥{{
                  (order.no_tax_price + order.tax_fee - order.discount).toFixed(
                    2,
                  )
                }}</span
              >
            </div>
            <div class="option-div" v-if="discountEdit">
              <span
                ><el-button size="mini" type="text" @click="handleEditDiscount"
                  >提交审核</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  @click="
                    order.discount = order.origin_discount
                    discountEdit = false
                  "
                  >取消</el-button
                ></span
              >
            </div>
          </div>

          <div
            class="mt-10"
            v-if="
              order.status == 5 &&
              order.approve_status != 2 &&
              userInfo.id == order.user_id
            "
            v-permission="Auth.commodityOrderManage"
          >
            <el-button type="danger" @click="orderPay">确认支付</el-button>
          </div>
        </div>
      </div>
    </div>
    <pay-former
      :model="model"
      :show.sync="payFormVisible"
      @updated="payedCallback"
    ></pay-former>

    <CommoditySelector
      :show.sync="productSelectorVisible"
      :orderid="order.id"
      @selected="doneSelectedProducts"
    ></CommoditySelector>

    <DiscountApplicationFormer
      :model="discountRemarkModel"
      :show.sync="discountRemarkDialog"
      @updated="discountUpdated"
    ></DiscountApplicationFormer>
  </div>
</template>

<script>
import {
  commodityOrderDetail,
  commodityOrderApprove,
  deleteCommodityOrder,
  deleteCommodityOrderItem,
  updateCommodityOrderItem,
  commodityOrderInit,
  updateCommodityOrder,
  updateCommodityOrderStatus,
  commodityOrderContractExport,
  updateCommodityOrderDiscount,
  approveCommodityOrderDiscount,
} from '@/service/getData'
import { isMobile } from '../../../util'
import { CodeToText } from '@/util/area_tool'
import PayFormer from './pay_former_new'
import {
  CommodityOrderStatusMap,
  CommodityOrderQuotationMap,
} from '@/config/global'
import auth from '@/util/auth'
import store from '@/store/store'
import { host } from '@/config/env'
import { hasAuth } from '@/permission'
import { urlPerfix } from '../../../config/env'
import download from 'downloadjs'
import CommoditySelector from './commodity_selector'
import DiscountApplicationFormer from './discount_application_former'

const flowCategoryMap = {
  1: '创建订单',
  3: '商品编辑',
  5: '批量订单审批',
  10: '下单商品审批',
  15: '底价商品审批',
  20: 'EC审批',
  30: '总价审批',
  40: '调价审批',
  50: '支付',
  60: 'EC复审',
}

export default {
  components: {
    PayFormer,
    CommoditySelector,
    DiscountApplicationFormer,
  },
  data() {
    return {
      productSelectorVisible: false,
      fileUploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      flowKey: 0,
      flowCategoryMap,
      flowActiveIndex: -1,
      hasAuth,
      host,
      userInfo: store.getters.userInfo,
      auth,
      model: {},
      payFormVisible: false,
      codeToText: CodeToText,
      isMobile,
      order: {
        id: 0,
        items: [],
        flows: [],
        customer: {},
        discount: 0,
        no_tax_price: 0,
        tax_fee: 0,
        total_price: 0,
        flow_id: 0,
        dealer: {},
      },
      showInvoiceInfo: false,
      CommodityOrderStatusMap,
      CommodityOrderQuotationMap,
      discountEdit: false,
      approveStatusMap: {
        1: { type: '', info: '' },
        2: { type: '', info: '审批中' },
        3: { type: 'danger', info: '审批未通过' },
        4: { type: 'success', info: '审批已通过' },
      },
      editModel: {
        edit: false,
        quotation_number: '',
      },
      discountRemarkDialog: false,
      discountRemarkModel: {},
      quotationMap: {
        1: '商城订单',
        2: '平台报价',
        3: '小程序询价',
      },
    }
  },
  created() {
    this.getData()
  },
  computed: {
    approveflows() {
      this.flowActiveIndex = -1
      let flows = this.order.flows
        .sort(function (x, y) {
          return x.category - y.category
        })
        .map((item, index) => {
          item.categoryName = flowCategoryMap[item.category]
          if (item.role_name) {
            item.categoryName += `（${item.role_name}）`
          }
          if (item.status == 0 && this.flowActiveIndex == -1) {
            this.flowActiveIndex = index
          }
          return item
        })

      if (this.flowActiveIndex == -1) {
        this.flowActiveIndex = flows.length
      }
      return flows
    },

    canEditItem() {
      return hasAuth('commodityOrderItemUpdate') && this.order.status == 4
    },
  },
  methods: {
    canApproveFlow(f) {
      if (
        this.order.status != 2 &&
        this.order.status != 4 &&
        this.order.status != 12 &&
        this.order.status != 5
      ) {
        return false
      }
      if (f.category == 1 || f.category == 50) {
        return false
      }

      let flow = this.order.flows.filter((item) => item.id == f.id)[0]
      let approver = flow.approver.filter((item) => item.id == this.userInfo.id)
      return approver.length > 0
    },
    async getData() {
      let res = await commodityOrderDetail(this.$route.params.id)
      if (res.code == 0) {
        let data = res.data
        if (data.receive_address_id > 0) {
          data.receive_address = data.addresses.filter(
            (item) => item.category == 1,
          )[0]
        }
        if (data.invoice_address_id > 0) {
          data.invoice_address = data.addresses.filter(
            (item) => item.category == 2,
          )[0]
        }

        if (data.flows.length == 0) {
          let flow = {
            category: 50,
            id: -1,
            operate_time: null,
            operate_type: 0,
            status: 0,
          }

          if (data.payed_at) {
            flow.operate_time = data.payed_at
            flow.status = 1
          }
          data.flows.push(flow)
        }

        data.flows.push({
          category: 1,
          id: -2,
          operate_time: data.created_at,
          operate_type: 1,
          status: 1,
        })

        data.items.map((item) => {
          item.edit = false
        })
        this.order = data
        this.flowKey = Math.random()
      }
    },
    orderPay() {
      this.model = {
        id: this.order.id,
        payed_proof: '',
        payed_remark: '',
      }
      this.payFormVisible = true
    },
    payedCallback(data) {
      this.getData()
      this.$emit('updateGoingCount')
    },
    handleApprove(category = 0) {
      let data = { id: this.order.id, agree: true }
      let _this = this

      if (category == 3) {
        this.$confirm('确认完成商品编辑吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          let res = await commodityOrderInit({ id: this.order.id })
          if (res.code == 0) {
            _this.getData()
          }
        })
        return
      }

      let cancelButtonText = '退回'
      if (category == 5) {
        cancelButtonText = '通过（变更为非批量订单）'
      }

      this.$prompt('备注', '订单审批', {
        distinguishCancelAndClose: true,
        confirmButtonText: '通过',
        cancelButtonText: cancelButtonText,
        inputPlaceholder: '选填',
        callback: async function (action, instance) {
          data.agree = action == 'confirm'
          data.remark = instance.inputValue

          if (action == 'confirm' || action == 'cancel') {
            if (category == 40) {
              _this.submitApprovalResult(data.agree, data.remark)
            } else {
              let res = await commodityOrderApprove(data)
              if (res.code == 0) {
                _this.getData()
                _this.$emit('updateGoingCount')
              }
            }
          }
        },
      })
    },

    async handleApplication() {
      let res = await updateCommodityOrderStatus({ id: this.order.id })
      if (res.code == 0) {
        if (res.data.status == 0) {
          this.$router.push(
            `/dashboard/shop/orders/editor?order=${res.data.id}`,
          )
          return
        }
        this.getData()
        this.$message.success('提交成功！')
      }
    },

    commodityItemEdit(index, item) {
      this.order.items[index].edit = true
    },

    async commodityItemUpdate(index, item) {
      let res = await updateCommodityOrderItem({
        id: item.id,
        price: parseFloat(item.discount_price),
        number: parseInt(item.number),
      })

      if (res.code == 0) {
        this.$notify({
          title: '操作提示',
          message: '保存成功！',
          type: 'success',
          duration: 2000,
        })
        this.getData()
      }
    },

    async deleteCommodityItem(index, item) {
      let res = await deleteCommodityOrderItem(item.id)
      if (res.code == 0) {
        this.getData()
      }
    },
    async handleEditDiscount() {
      if (this.order.discount == this.order.origin_discount) {
        this.$alert('折扣金额无变化，请重新输入！')
        return
      }

      this.discountRemarkModel = {
        id: this.order.id,
        discount: this.order.discount,
        discount_remark: '',
      }
      this.discountRemarkDialog = true
      return

      let _this = this
      this.$prompt('调价备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '选填',
        callback: async function (action, instance) {
          if (action == 'confirm') {
            let res = await updateCommodityOrderDiscount({
              id: _this.order.id,
              discount: _this.order.discount,
              discount_remark: instance.inputValue,
            })
            if (res.code == 0) {
              _this.discountEdit = false
              _this.getData()
              _this.$message({
                message: '操作成功',
                type: 'success',
              })
            }
          }
        },
      })
    },

    discountUpdated() {
      this.discountEdit = false
      this.getData()
      this.$message({
        message: '操作成功',
        type: 'success',
      })
    },
    async submitApprovalResult(result, remark) {
      let res = await approveCommodityOrderDiscount({
        id: this.order.id,
        result: result,
        remark: remark,
      })
      if (res.code == 0) {
        this.$message({
          message: '操作成功',
          type: 'success',
        })
        this.getData()
      }
    },
    async handleDelete() {
      let res = await deleteCommodityOrder(this.order.id)
      if (res.code == 0) {
        this.$alert('订单已删除')
        if (this.order.status == 0) {
          this.$router.push('/dashboard/shop/application_orders')
        } else {
          this.$router.push('/dashboard/shop/approve_orders')
        }
      }
    },
    async handleReturn() {
      let res = await commodityOrderInit({ id: this.order.id })
      if (res.code == 0) {
        this.$message({
          message: '操作成功，请在商品信息处进行商品编辑',
          type: 'success',
        })
        this.getData()
      }
    },
    async handleCancel() {
      let res = await updateCommodityOrderStatus({ id: this.order.id })
      if (res.code == 0) {
        this.getData()
        this.$emit('updateGoingCount')
      }
    },
    async handleContractExport(type = 0) {
      let res = await commodityOrderContractExport({
        id: this.order.id,
        contract_type: type,
      })
      if (res.code == 0) {
        let href = res.data
        window.location.href = href
      }
    },

    async handleOrderUpdate() {
      let data = {
        id: this.order.id,
        quotation_number: this.editModel.quotation_number,
      }

      if (!data.quotation_number) {
        this.$alert('Quotation码不能为空')
        return
      }

      let res = await updateCommodityOrder(data)
      if (res.code == 0) {
        this.order.quotation_number = data.quotation_number
        this.editModel.edit = false
        this.$message({
          message: '修改成功',
          type: 'success',
        })
      }
    },

    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 < this.uploadLimitSize.file
      if (!isLimitSize) {
        this.$message.error(`文件大小不能超过 ${this.uploadLimitSize.file}MB!`)
      }
      return isLimitSize
    },
    async handleFileSuccess(res, file) {
      if (res.code == 0) {
        let data = {
          id: this.order.id,
          contract: {
            name: file.name,
            url: res.data,
            user_name: this.userInfo.name,
          },
        }

        let r = await updateCommodityOrder(data)
        if (r.code == 0) {
          this.order.contract = data.contract
          this.$message({
            message: '合同上传成功',
            type: 'success',
          })
        }
      }
    },

    doneSelectedProducts(res) {
      this.getData()
    },

    download(file) {
      var x = new XMLHttpRequest()
      x.open('GET', file.url + '?t=' + this.FileToken, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        download(e.target.response, file.name)
      }
      x.send()
    },
  },
}
</script>

<style scoped>
.item-container {
  display: flex;
  align-content: flex-start;
}
.item-info {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}
.optipn-fight {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: right;
}
.optipn-fight div {
  margin-bottom: 5px;
}
.optipn-fight div span {
  min-width: 130px;
  text-align: right;
  display: inline-block;
}
.pay-amount {
  color: #e4393c;
}
.pay-amount span {
  font-size: 1.3em;
  font-weight: bold;
}
.option-bar {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  /* border-top: 1px solid #ebeef5; */
  padding-top: 20px;
}
/deep/.el-form-item--mini {
  margin-bottom: 0px;
}
/deep/.el-form-item--mini .el-form-item__label,
/deep/.el-form-item--mini .el-form-item__content {
  font-size: 13px;
}
/deep/.el-tag--default {
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
}
.invoice-container {
  border: 1px solid #ebeef5;
  margin-bottom: 4px;
}
.invoice-container div {
  border-bottom: 1px solid #ebeef5;
  padding: 4px;
}
.invoice-container div:nth-last-child(1) {
  border-bottom: none;
}
.invoice-container div span.label {
  display: inline-block;
  width: 90px;
  text-align: right;
  margin-right: 15px;
}
.item-desc {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 2.8em;
  line-height: 1.4em;
  color: #666;
}
.part-number {
  color: #666;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.order-option-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.discount-edit-btn,
.option-div i {
  font-style: normal;
  margin-left: 5px;
  cursor: pointer;
}
.approve-container {
  background: #fdefd9;
  border-radius: 6px;
  padding: 12px 20px;
  font-size: 13px;
  font-weight: bold;
  margin-left: -5px;
  margin-right: -5px;
  padding-left: 25px;
}
.item-title {
  display: flex;
  justify-content: space-between;
}
.text-line-through {
  /* text-decoration: line-through; */
  color: #c0c4cc;
}
</style>
<style>
.order-step .el-step__title {
  line-height: 1.5em;
  margin-bottom: 15px;
  margin-top: 10px;
}
.small .el-image__error {
  font-size: 12px;
}
</style>
